import { VelavuEventOptions, VelavuRuleAction } from "velavu-js-api";

export interface RulesEventInputState {
	message: string;
	phoneNumbers: string;
	emailAddresses: string;
	storeEvent: boolean;
	storeAlert: boolean;
}

export const RULES_EVENT_INPUT_STATE_DEFAULT: Readonly<RulesEventInputState> = {
	message: "",
	phoneNumbers: "",
	emailAddresses: "",
	storeEvent: false,
	storeAlert: false,
};

export function rulesEventInputStateFromEventOptions(
	options: VelavuEventOptions | undefined,
): RulesEventInputState | null {
	if (options === undefined) {
		return null;
	}

	return {
		message: options.message,
		phoneNumbers: options.sms_numbers?.join(", ") ?? "",
		emailAddresses: options.email_addresses?.join(", ") ?? "",
		storeEvent: options.store_event ?? false,
		storeAlert: options.store_alert ?? false,
	};
}
